<div class="tour_stopover_container">
  @if (view.tour_idxs.length) {
    <div class="tour_stopover_child">
      <div class="idxs_container" [style.min-width]="Math.min(view.tour_idxs.length * 24, 144) + 'px'">
        @if (view.type === "show") {
          @for (tour_idx of view.tour_idxs; track tour_idx.operation_id) {
            <div
              class="idx"
              style="color: white; font-weight: bold; font-size: 12px"
              [style.background-color]="tour_idx.color"
            >
              {{ tour_idx.idx }}
              @if (tour_idx.started || tour_idx.done) {
                <div class="operation_status_indicator">
                  @if (tour_idx.started && !tour_idx.done) {
                    <fa-icon style="margin: auto" [icon]="faWrench"></fa-icon>
                  }
                  @if (tour_idx.done) {
                    <fa-icon style="margin: auto" [icon]="faCheck"></fa-icon>
                  }
                </div>
              }
            </div>
          }
        }
        @if (view.type === "edit") {
          @for (tour_idx of view.tour_idxs; track tour_idx.operation_id) {
            <div
              class="idx"
              style="color: white; font-weight: bold; font-size: 12px"
              [style.background-color]="tour_idx.color"
            >
              {{ tour_idx.idx }}
              @if (view.tourStopoverEditModule && !tour_idx.started) {
                <div class="visible_on_idx_hover" style="overflow: visible" [style.background-color]="tour_idx.color">
                  @if (view.tourStopoverEditModule.isMainMapContainer()) {
                    <div
                      class="horizontal_flex"
                      style="width: 100%"
                      (click)="view.tourStopoverEditModule.clickIdx(tour_idx)"
                    >
                      <div style="margin: auto">
                        <fa-icon [icon]="faEye" [tooltip]="'Tour öffnen'"></fa-icon>
                      </div>
                    </div>
                  }
                  @if (!view.tourStopoverEditModule.isMainMapContainer()) {
                    <div
                      class="vertical_flex show_on_parent_hover"
                      style="
                        position: absolute;
                        z-index: 5;
                        bottom: 0;
                        left: 50%;
                        transform: translate(-50%, 0);
                        overflow: visible;
                      "
                    >
                      <div
                        class="horizontal_flex"
                        style="border: 1px solid black; background-color: white; color: white; overflow: visible"
                      >
                        @if (tour_idx.tour.technicianDate.insertionConfigMap.has(tour_idx.operation_id)) {
                          <div
                            class="black_gradient_background"
                            style="border: 1px solid black; display: inline-flex; padding: 2px"
                            (click)="
                              tour_idx.tour.technicianDate.insertionConfigMap.get(tour_idx.operation_id).removable =
                                !tour_idx.tour.technicianDate.insertionConfigMap.get(tour_idx.operation_id).removable;
                              tour_idx.tour.technicianDate.updateNewTourConfig()
                            "
                          >
                            <fa-icon
                              style="margin: auto"
                              [icon]="
                                tour_idx.tour.technicianDate.insertionConfigMap.get(tour_idx.operation_id).removable
                                  ? faLockOpen
                                  : faLock
                              "
                            ></fa-icon>
                          </div>
                        }
                        <select
                          class="bm-select bm-select-sm"
                          style="width: 90px; margin: 2px 4px; color: black"
                          [disabled]="tourIdxSelectionChangeIsDisabledForOperation(tour_idx.operation_id)"
                          (change)="changeTourIdxSelection(tour_idx, $event)"
                        >
                          <option
                            [value]="-1"
                            [selected]="
                              (tour_idx.tour.technicianDate.insertionConfigMap.get(tour_idx.operation_id)?.tour_index ??
                                -1) === -1
                            "
                          >
                            Opt
                          </option>
                          @for (idx of tour_idx.tour.technicianDate.freeTourIndexes; track idx) {
                            <option
                              [value]="idx"
                              [disabled]="tour_idx.tour.technicianDate.insertionConfigIndexIsDisabled(idx, tour_idx.operation_id)"
                              [selected]="
                                tour_idx.tour.technicianDate.insertionConfigMap.get(tour_idx.operation_id)
                                  ?.tour_index === idx
                              "
                            >
                              {{ idx + 1 }}
                            </option>
                          }
                        </select>
                        <div
                          class="horizontal_flex black_gradient_background"
                          style="border: 1px solid black"
                          (click)="view.tourStopoverEditModule.clickIdx(tour_idx)"
                        >
                          <div style="margin: auto">
                            <div style="font-size: 0.9rem; padding: 2px" [tooltip]="'Aus Tour entfernen'">
                              <fa-icon [icon]="faTrash"></fa-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (tour_idx.started || tour_idx.done) {
                <div class="operation_status_indicator">
                  @if (tour_idx.started && !tour_idx.done) {
                    <fa-icon style="margin: auto" [icon]="faWrench"></fa-icon>
                  }
                  @if (tour_idx.done) {
                    <fa-icon style="margin: auto" [icon]="faCheck"></fa-icon>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }
  @if (view.type === "edit") {
    @if (
      view.tourStopoverEditModule.notInsertedOperations.length && !view.tourStopoverEditModule.isMainMapContainer()
    ) {
      <div class="not_in_tour not_inserted tour_stopover_child">
        <div class="idxs_container" style="min-width: 24px">
          <div class="idx" style="border: 1px solid black" [style.background-color]="'rgba(255, 255, 255, .5)'">
            &#x2716;
            <div
              class="visible_on_idx_hover"
              [style.background-color]="'#1f1f1f'"
              [tooltip]="'Fest in Tour setzen'"
              (click)="view.tourStopoverEditModule.makeNotInsertedOperationsUnremovable()"
            >
              <div style="margin: auto">
                <div style="font-size: 1rem; color: white"><fa-icon [icon]="faLock"></fa-icon></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (view.tourStopoverEditModule.deletedOperations.length && !view.tourStopoverEditModule.isMainMapContainer()) {
      <div class="not_in_tour deleted tour_stopover_child">
        <div class="idxs_container" style="min-width: 24px">
          <div class="idx" style="border: 1px solid black" [style.background-color]="'rgba(255, 255, 255, .8)'">
            &#x2716;
            <div
              class="visible_on_idx_hover"
              [style.background-color]="'#1f1f1f'"
              (click)="view.tourStopoverEditModule.addStoreOperationsToNewTour()"
            >
              <div style="margin: auto">
                <div style="font-size: 1rem; color: greenyellow" [tooltip]="'Entfernen rückgängig machen'">
                  <fa-icon [icon]="faPlus"></fa-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
